import React, { useState } from "react";
import { DatePicker, Radio, Tabs, TimePicker } from "antd";
import dayjs from "dayjs";
import styles from "./style.module.css";
import MultiDatePicker from "react-multi-date-picker";
import tostMessage from "../../utils/tostMessage";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import { useDispatch, useSelector } from "react-redux";
import {
  setMode,
  setSelectedRangeDate,
  setSelectedTimeRange,
  setMultiDate,
  setSelectedTab,
} from "../../redux/slice/filterSlice.js";
import { Grid } from "@mui/material";
import { AiFillCaretDown } from "react-icons/ai";
import { AiFillCaretUp } from "react-icons/ai";
import { Popover } from "antd";
const { RangePicker } = DatePicker;
function FilterBox({ tabHide, isTime }) {
  const dispatch = useDispatch();
  let {
    mode,
    selectedRangeDate,
    multiDate,
    tabList,
    selectedTab,
    structureData,
    selectedTimeRange,
  } = useSelector((state) => state.filter);

  const [open, setOpen] = useState(false);
  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      dispatch(setSelectedRangeDate(dates));
    } else {
      console.log("Clear");
    }
  };
  const onTimeRangeChange = (dates, dateStrings) => {
    if (dates) {
      dispatch(setSelectedTimeRange(dates));
    } else {
      console.log("Clear");
    }
  };
  const handleSelect = (e) => {
    dispatch(setMode(e.target.value));
  };
  const disabledDate = (current) => {
    return current && current?.isAfter(dayjs()?.endOf("day"));
  };
  const isFutureDate = (date) => {
    return dayjs(date)?.isAfter(dayjs()?.endOf("day"));
  };
  const handleDateChange = (newValues, val) => {
    if (newValues.some((date) => isFutureDate(date))) {
      tostMessage(400, "Can't select future Date");
    }
    dispatch(setMultiDate(newValues.filter((date) => !isFutureDate(date))));
  };
  const onChange = (key) => {
    let data = tabList.filter((item) => item.key === key)[0];
    let val = structureData.filter(
      (item) => item?.alert_type?._id === data?.value
    )[0]?.structure;
    dispatch(setSelectedTab({ tab: data, structure: val }));
  };
  const handleOpenChange = () => {
    setOpen((pre) => !pre);
  };

  const content = (
    <Grid container spacing={3} className={styles.box2}>
      <Grid item xs={12}>
        <div
          style={{
            marginBottom: "1rem",
          }}
        >
          <Radio.Group onChange={handleSelect} value={mode}>
            <Radio.Button value={0}>Date Range</Radio.Button>
            <Radio.Button value={1}>Multi Date</Radio.Button>
          </Radio.Group>
        </div>

        {mode === 0 ? (
          <RangePicker
            onChange={onRangeChange}
            value={selectedRangeDate}
          />
        ) : (
          <MultiDatePicker
            multiple
            placeholder="Select Multiple Date"
            style={{ padding: "15px", width: "18.5rem" }}
            value={multiDate}
            onChange={handleDateChange}
            plugins={[
              <DatePanel position="left" sort="date" />,
              <Toolbar
                position="bottom"
                sort={["today", "close"]}
                names={{
                  today: "Reset",
                  close: "Close",
                }}
              />,
            ]}
          />
        )}
      </Grid>
      {isTime && (
        <Grid item xs={12}>
          <TimePicker.RangePicker
            style={{ width: "18.5rem" }}
            defaultValue={selectedTimeRange}
            onChange={onTimeRangeChange}
          />
        </Grid>
      )}
    </Grid>
  );
  return (
    <Grid container spacing={2} className={styles.box}>
      <Grid item xs={12} sm={12}>
        <div className={styles.navBar}>
          <div className={styles.oneLine}>
            {!tabHide ? (
              <Tabs
                activeKey={selectedTab?.key}
                items={tabList}
                onChange={onChange}
                size="large"
              />
            ) : null}
          </div>
          <div>
            <Popover
              content={content}
              title="Filter"
              trigger="click"
              placement="bottomRight"
              open={open}
            >
              <button className={styles.btn} onClick={handleOpenChange}>
                Filter {!open ? <AiFillCaretDown /> : <AiFillCaretUp />}
              </button>
            </Popover>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export default FilterBox;
